import ApiService from "@/services/api.service"

export const PatientService = {
	getPatient(id) {
		return ApiService.get(`patient/${id}`)
	},
	getClientTeeth(id) {
		return ApiService.get(`patient/${id}/teeth`, {}, { loader: false })
	},
	getClientAnketa(id) {
		return ApiService.get(`patient/${id}/anketa`)
	},
	getBirthdays() {
		return ApiService.get(`patients/birthdays`)
	},
	sendBirthdayGreetings(params) {
		return ApiService.post(`patients/birthdays`, params)
	},
	saveClientAnketa(id, params) {
		return ApiService.post(`patient/${id}/anketa`, params)
	},
	signClientAnketa(id) {
		return ApiService.post(`patient/${id}/anketa/sign`)
	},
	sendAnketaViaMessenger(id, params) {
		return ApiService.post(`patient/${id}/anketa/send`, params)
	},
	updateClientTeeth(patient_id, tooth_id, params) {
		return ApiService.post(`patient/${patient_id}/teeth/${tooth_id}/update`, params)
	},
	getVisitDictionaries(patient_id, visit_id = null) {
		return ApiService.get(`patient/${patient_id}/visits/dictionaries`, { visit_id: visit_id })
	},
	attachPlan(patient_id, visit_id, plan_visit_id) {
		return ApiService.post(`patient/${patient_id}/visit/${visit_id}/plan/${plan_visit_id}/attach`)
	},
	attachPlanWithOptions(patient_id, visit_id, plan_visit_id, options) {
		return ApiService.post(`patient/${patient_id}/visit/${visit_id}/plan/${plan_visit_id}/options/attach`, { options })
	},
	cancelPlan(patient_id, visit_id, plan_visit_id) {
		return ApiService.post(`patient/${patient_id}/visit/${visit_id}/plan/${plan_visit_id}/cancel`)
	},
	attachTemplate(patient_id, visit_id, template_id, options = [], teeth = [], allTeeth = []) {
		return ApiService.post(`patient/${patient_id}/visit/${visit_id}/template/${template_id}/attach`, { options: options, teeth: teeth, allTeeth: allTeeth })
	},
	getClientVisit(patient_id, visit_id, loader = true) {
		return ApiService.get(`patient/${patient_id}/visit/${visit_id}`, {}, { loader })
	},
	getClientPlan(patient_id, plan_id) {
		return ApiService.get(`patient/${patient_id}/plan/${plan_id}`)
	},
	getUnpaidServices(patient_id, dateTo = '') {
		return ApiService.get(`patient/${patient_id}/visits/unpaid?dateTo=${dateTo || ''}`)
	},
	// payForVisit(patient_id, visit_id = null, params = {}) { // not used anymore: replaced by payForVisitNew
	// 	return ApiService.post(`patient/${patient_id}/visit/${visit_id || 'material'}/pay`, params)
	// },
	payForVisitNew(patient_id, visit_id = null, params = {}) {
		return ApiService.post(`patient/${patient_id}/visit/${visit_id || 'material'}/pay/new`, params)
	},
	refundPay(pay_id, params) {
		return ApiService.post(`payments/${pay_id}/refund`, params)
	},
	generateChequeForPayment(pay_id, params) {
		return ApiService.post(`payments/${pay_id}/cheque/issue`, params)
	},
	toggleTag(patient_id, tag_id) {
		return ApiService.post(`patient/${patient_id}/tag/${tag_id}/toggle`)
	},
	syncFamilyAccount(patient_id, user_ids = []) {
		return ApiService.post(`patient/${patient_id}/family_account/`, { user_ids: user_ids })
	},
	toggleFamilyAccountActivity(patient_id, params) {
		return ApiService.post(`patient/${patient_id}/family_account/activity`, params)
	},
	checkIfPhoneExists(patient_id, phone) {
		return ApiService.get(`patient/phone/exists`, { patient_id: patient_id, phone: phone }, { loader: false })
	},
	checkIfNameExists(params) {
		return ApiService.get(`patient/name/exists`, params, { loader: false })
	},
	unifyCard(patient_id, destination_user_id) {
		return ApiService.post(`patient/${patient_id}/unify/`, { destination_user_id: destination_user_id })
	},
	sendFormulaImage(patient_id, data) {
		return ApiService.post(`patient/${patient_id}/formula/image/upload`, { img: data })
	},
	getClientSources() {
		return ApiService.get(`patients/sources`)
	},
	patientHasFutureRecords(patient_id) {
		return ApiService.get(`patients/${patient_id}/has_future_records`)
	},
	setUUIDForPayment(payment_id, params) {
		return ApiService.post(`payments/${payment_id}/uuid`, params)
	},
	fillDescriptionsFromVisit(params) {
		return ApiService.post(`patients/records/descriptions/repeat`, params)
	},
	signTreatmentPlan(plan_id, params) {
		return ApiService.post(`plan_treatments/${plan_id}/sign`, params, {'Content-Type': 'multipart/form-data'})
	},
	deleteSignTreatmentPlan(plan_id) {
		return ApiService.delete(`plan_treatments/${plan_id}/sign`)
	},
	guessAddress(query) {
		return ApiService.get(`address/guess?q=${query}`)
	},
	guessSnils(patientId, data) {
		return ApiService.post(`patient/${patientId}/snils/guess`, data)
	},
	transferBetweenDepositAccounts(patientId, params) {
		return ApiService.post(`patient/${patientId}/deposit/internal/transfer`, params)
	},
	getInsuranceData(patientId, day) {
		return ApiService.get(`patient/${patientId}/insurance/data?day=${day}`)
	},
	getServicesTree(insuranceCompanyId) {
		return ApiService.get(`price/services/tree?insuranceCompanyId=${insuranceCompanyId}`)
	},
	resetAnketaFilling(patientId) {
		return ApiService.post(`patient/${patientId}/anketa/reset`)
	},
	loadTemplatesForDiagnoses(diagnosisIds) {
		return ApiService.get(`diagnosis/templates`, { diagnosisIds })
	},
	loadPlanTemplatesForDiagnoses(diagnosisIds) {
		return ApiService.get(`diagnosis/plan_templates`, { diagnosisIds })
	},
	toggleDiagnosisFavourite(diagnosisId) {
		return ApiService.post(`diagnosis/favourite/${diagnosisId}/toggle`)
	},
	planTreatmentUserSession(planId, params) {
		return ApiService.post(`plan_treatments/${planId}/session/toggle`, params, {}, {loader: false})
	},
	getPlanTreatmentCompletedDetails(planId) {
		return ApiService.get(`plan/${planId}/details/completed`)
	}
}
